/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./infoDialog.vue?vue&type=template&id=56c8eb53&scoped=true"
import script from "./infoDialog.vue?vue&type=script&lang=js"
export * from "./infoDialog.vue?vue&type=script&lang=js"
import style0 from "./infoDialog.vue?vue&type=style&index=0&id=56c8eb53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c8eb53",
  null
  
)

export default component.exports